import React, { Fragment } from 'react';
import { Input, Label, Row, Col } from 'reactstrap';
import NumberInput from '../Inputs/NumberInput';

class FormRenderField extends React.Component {

    componentDidMount = () => {
        this.props.log('FormRenderField.js/componentDidMount');
    }

    renderField = (field, fieldIndex) => {
        this.props.info('FormRenderField.js/renderField (field, fieldIndex)', field, fieldIndex);
        let value = '';
        if (String(field.uniqueId).indexOf('|') > -1) {
            let nameArr = String(field.uniqueId).split('|');
            if (this.props.data[nameArr[0]][parseInt(nameArr[1])] != null && this.props.data[nameArr[0]][parseInt(nameArr[1])][nameArr[2]] != null) {
                value = this.props.data[nameArr[0]][parseInt(nameArr[1])][nameArr[2]];
            }
        } else {
            value = this.props.data[field.uniqueId];
        }
        let placeholder = '';
        if (field.rules != null && field.rules.placeholder != null && field.rules.placeholder !== '') {
            placeholder = field.rules.placeholder;
        } else if (field.placeholder != null && field.placeholder !== '') {
            placeholder = field.placeholder;
        }
        let attributeObj = {};
        if (this.props.targetFields != null) {
            this.props.targetFields.filter(targetField => targetField.field === field.uniqueId).forEach(targetField => {
                switch(targetField.attribute) {
                    case "min":
                        attributeObj.min = (targetField.operator === '>') ? 
                            new Date(new Date(this.props.targetFieldsValue+'T00:00:00').getTime() + (3600 * 1000 * 24)).toISOString().slice(0, 10)
                            :
                            this.props.targetFieldsValue;
                        break;
                    default:
                        attributeObj[targetField.attribute] = this.props.targetFieldsValue;
                }
            })
        }
        switch (field.type.toLowerCase()) {
            case "boolean":
            case "radio":
                return (
                    <>
                        <Label>
                            <Input
                                name={field.uniqueId}
                                type="radio"
                                value="true"
                                checked={(this.props.data[field.uniqueId] === 'true')}
                                onChange={(e) => this.props.onChange(e)}
                                onBlur={(e) => this.props.onBlur(e)}
                                innerRef={field.uniqueId === this.props.config.autofocus ? this.inputFocus : null}
                                tabIndex={fieldIndex}
                                disabled={field.disabled != null && field.disabled}
                            />
                            Yes
                        </Label>
                        <Label>
                            <Input
                                name={field.uniqueId}
                                type="radio"
                                value="false"
                                checked={this.props.data[field.uniqueId] === 'false' && this.props.data[field.uniqueId] !== ''}
                                onChange={(e) => this.props.onChange(e)}
                                onBlur={(e) => this.props.onBlur(e)}
                                tabIndex={fieldIndex}
                                disabled={field.disabled != null && field.disabled}
                            />
                            No
                        </Label>
                    </>
                );
            case "checkbox":
                return (
                    <Input
                        name={field.uniqueId}
                        type="checkbox"
                        value="true"
                        checked={(this.props.data[field.uniqueId] === 'true' || this.props.data[field.uniqueId] === true) ? true : false}
                        onChange={(e) => this.props.onChange(e)}
                        onBlur={(e) => this.props.onBlur(e)}
                        innerRef={field.uniqueId === this.props.config.autofocus ? this.inputFocus : null}
                        tabIndex={fieldIndex}
                        disabled={field.disabled != null && field.disabled}
                    />
                );
            case "select":
                return (
                    <Input
                        type="select"
                        name={field.uniqueId}
                        value={this.props.isFieldNull(value)}
                        onChange={(e) => this.props.onChange(e)}
                        onBlur={(e) => this.props.onBlur(e)}
                        innerRef={field.uniqueId === this.props.config.autofocus ? this.inputFocus : null}
                        tabIndex={fieldIndex}
                        disabled={field.disabled != null && field.disabled}
                    >
                        <option value="-1">SELECT</option>
                        {field.options != null && field.options[0].options != null && field.options[0].options !== '' ? field.options[0].options.split('\n').map((option, optionIndex) => (
                            <Fragment key={optionIndex}>{typeof (option) === 'object' ?
                                <>
                                    {option.label !== '' ? <option value={option.value.replaceAll('\\/', '/')}>{option.label.replaceAll('\\/', '/')}</option> : <></>}
                                </>
                                :
                                <>
                                    {option !== '' ? <option value={option.replaceAll('\\/', '/')}>{option.replaceAll('\\/', '/')}</option> : <></>}
                                </>
                            }</Fragment>
                        )) : null}
                    </Input>
                )
            case "multiple":
                const numRows = (typeof (this.props.data[field.uniqueId]) !== 'object') ? 1 : this.props.data[field.uniqueId].length + 1;
                return (
                    <>{[...Array(numRows).keys()].map((row, rowIndex) => (
                        <Row key={rowIndex}>
                            <>{field.rules != null && field.rules.columns != null ?
                                <>{field.rules.columns.map((column, columnIndex) => (
                                    <Col key={columnIndex} className="px-1">
                                        {this.renderField({ ...column, placeholder: column.placeholder, uniqueId: field.uniqueId + '|' + row + '|' + column.key }, fieldIndex + (rowIndex * 10) + columnIndex)}
                                    </Col>
                                ))}
                                </>
                                : null}
                                <Col md={2}></Col>
                            </>
                        </Row>
                    ))}</>
                )
            case "currency":
                return (
                    <NumberInput
                        info={this.props.info}
                        log={this.props.log}
                        name={field.uniqueId}
                        value={this.props.isFieldNull(value)}
                        onChange={(e) => this.props.onChange(e)}
                        onBlur={(e) => this.props.onBlur(e)}
                        innerRef={field.uniqueId === this.props.config.autofocus ? this.inputFocus : null}
                        tabIndex={fieldIndex}
                        disabled={field.disabled != null && field.disabled}
                        type="currency"
                        placeholder={this.props.isFieldNull(placeholder)}
                    />
                )
            case "number":
                return (
                    <NumberInput
                        info={this.props.info}
                        log={this.props.log}
                        name={field.uniqueId}
                        value={this.props.isFieldNull(String(parseFloat(value)).replace(/^0+/, ''))}
                        onChange={(e) => this.props.onChange(e)}
                        onBlur={(e) => this.props.onBlur(e)}
                        innerRef={field.uniqueId === this.props.config.autofocus ? this.inputFocus : null}
                        tabIndex={fieldIndex}
                        disabled={field.disabled != null && field.disabled}
                        placeholder={this.props.isFieldNull(placeholder)}
                    />
                )
            case "date":
                return (
                    <Input
                        {...attributeObj}
                        type="date"
                        name={field.uniqueId}
                        value={this.props.isFieldNull(value)}
                        onChange={(e) => this.props.onChange(e)}
                        onBlur={(e) => this.props.onBlur(e)}
                        innerRef={field.uniqueId === this.props.config.autofocus ? this.inputFocus : null}
                        tabIndex={fieldIndex}
                        disabled={field.disabled != null && field.disabled}
                        placeholder={this.props.isFieldNull(placeholder)}
                    />
                )
            default:
                return (
                    <Input
                        type={field.type}
                        name={field.uniqueId}
                        maxLength={parseInt(field.limit) > 0 ? parseInt(field.limit) : null}
                        value={this.props.isFieldNull(value)}
                        onChange={(e) => this.props.onChange(e)}
                        onBlur={(e) => this.props.onBlur(e)}
                        innerRef={field.uniqueId === this.props.config.autofocus ? this.inputFocus : null}
                        tabIndex={fieldIndex}
                        disabled={field.disabled != null && field.disabled}
                        placeholder={this.props.isFieldNull(placeholder)}
                    />
                )
        }
    }

    render() {
        this.props.info('FormRenderField.js/render');
        return this.renderField(this.props.field, this.props.fieldIndex);
    }
}

export default FormRenderField;